// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { REGUS, SPACES } from 'src/app/shared/constants/brands.constants';

export const environment = {
  production: false,
  apiUrl: 'api/',
  localizationItemsLifeTime: 180, // Minutes
  googleMapsApiKeys: {
    [REGUS]: 'AIzaSyB9aBpCf8EI2dx7CHydniN3vzfnzSZTEQY',
    [SPACES]: 'AIzaSyB9aBpCf8EI2dx7CHydniN3vzfnzSZTEQY'
  },
  googleAnalyticsKeys: {
    [REGUS]: 'GTM-DQFW',
    [SPACES]: 'GTM-NHLMZC7D'
  },
  customerPortalLinks: {
    [REGUS]: 'https://uat.myregus.com/home',
    [SPACES]: 'https://uat.myspacesworks.com/home'
  },
  customerPortalLoginLinks: {
    [REGUS]: 'https://uat.myregus.com/loginCallback',
    [SPACES]: 'https://uat.myspacesworks.com/loginCallback'
  },
  dataLayerRegus: 'GTM-KNW8RBD',
  localizationPlaceholdersPrefix: 'ConsumerInput_',
  appInsightsConnectionString:
    'InstrumentationKey=8d71ca3e-cfed-4b19-aa1f-320701998611;IngestionEndpoint=https://westeurope-3.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=f96f86ed-8798-4d57-aa4c-c6b175b379fa',
  hCaptchaSiteKey: '2e784d56-8e78-4a60-adc8-c054b61afd4a',
  hCaptchaEnabled: true,
  TimeSlotsEnabled: false,
  ///
  EGYEInvoicingEnabled: true,
  TUREInvoicingEnabled: true,
  PRTEInvoicingEnabled: true,
  UGAEInvoicingEnabled: true,
  SRBEInvoicingEnabled: true,
  ROMEInvoicingEnabled: true,
  MYSEInvoicingEnabled: true,
  ISREInvoicingEnabled: true,
  DynamicEInvoicingEnabled: true
};
